import { RadioInput } from '@components/RadioInput'
import { RadioInputFieldProps } from './interface'

export function RadioInputField({ label, ...props }: RadioInputFieldProps) {
  return <RadioInput text={label} {...props} />
}
